import { createReducer, on } from '@ngrx/store';
import { saveBraches } from './branches.actions';

export const saveBrachesReducer = (_: any, { value }: { value: any }): any =>
    value;

export const BranchesReducer = createReducer(
    [],
    on(saveBraches, saveBrachesReducer),
);
